import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useGetSubCategoriesQuery } from "slices/beautyApp/subCatSlice";

function AddForm({ open, onClose, initialData, onSubmit }) {
  const { data, isLoading, refetch } = useGetSubCategoriesQuery({});

  const [formData, setFormData] = useState({
    category: "",
    subCategory: "",
    name: "",
    metaTitle: "",
    metaDescription: "",
    keywords: [], // <-- add keywords array here
  });
  const [keywordInput, setKeywordInput] = useState(""); // for the new keyword input

  useEffect(() => {
    if (initialData) {
      setFormData({
        ...initialData,
        keywords: initialData.keywords || [],
      });
    }
  }, [initialData]);

  const handleClose = () => {
    onClose();
    setFormData({
      category: "",
      subCategory: "",
      name: "",
      metaTitle: "",
      metaDescription: "",
      keywords: [],
    });
  };

  console.log("subcatttt", data);

  const handleSubmit = async () => {
    await onSubmit(formData);
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubCatChange = (selectedSubCat) => {
    setFormData((prev) => ({
      ...prev,
      subCategory: selectedSubCat._id,
      category: selectedSubCat.category,
    }));
  };

  const addKeyword = () => {
    const trimmed = keywordInput.trim();
    if (trimmed && !formData.keywords.includes(trimmed)) {
      setFormData((prev) => ({
        ...prev,
        keywords: [...prev.keywords, trimmed],
      }));
      setKeywordInput("");
    }
  };

  // Remove keyword by value
  const removeKeyword = (keywordToRemove) => {
    setFormData((prev) => ({
      ...prev,
      keywords: prev.keywords.filter((k) => k !== keywordToRemove),
    }));
  };

  // Handle Enter key press inside keyword input
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addKeyword();
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle> {initialData ? "Edit" : "Add"} </DialogTitle>
      <DialogContent dividers>
        <FormControl fullWidth margin="normal" required>
          <InputLabel id="category-label">Select Sub Category</InputLabel>
          <Select
            labelId="category-label"
            value={formData.subCategory || ""}
            label="Category"
            onChange={(e) => {
              const selectedSubCat = data?.data?.data.find(
                (item) => item._id == e.target.value
              );
              handleSubCatChange(selectedSubCat); // pass full subcategory (or destructure as needed)
            }}
          >
            {data?.data?.data && data.data.data.length > 0 ? (
              data.data.data.map((item) => (
                <MenuItem key={item._id} value={item._id}>
                  {item.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No categories found</MenuItem>
            )}
          </Select>
        </FormControl>
        <TextField
          label="Service Type Name"
          value={formData.name}
          onChange={(e) => handleChange("name", e.target.value)}
          fullWidth
          margin="normal"
          required
        />

        <TextField
          label="Meta Title"
          value={formData.metaTitle}
          onChange={(e) => handleChange("metaTitle", e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          label="Meta Description"
          value={formData.metaDescription}
          onChange={(e) => handleChange("metaDescription", e.target.value)}
          fullWidth
          margin="normal"
          required
        />

        {/* Keywords input and add button */}
        <Box display="flex" alignItems="center" mt={2} mb={1} gap={1}>
          <TextField
            label="Add Keyword"
            value={keywordInput}
            onChange={(e) => setKeywordInput(e.target.value)}
            onKeyDown={handleKeyDown}
            fullWidth
          />
          <Button onClick={addKeyword} variant="contained" color="primary">
            Add
          </Button>
        </Box>

        {/* Show keywords as Chips */}
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
          {formData?.keywords?.map((keyword) => (
            <Chip
              key={keyword}
              label={keyword}
              onDelete={() => removeKeyword(keyword)}
              color="primary"
            />
          ))}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          {initialData ? "Update" : "Add"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddForm;
